import { Component, Input } from '@angular/core';
import { EoTabConfig, EoTabsConfig, IEoTabsConfig } from './eo-tabs.model';
import { TabViewChangeEvent, TabViewCloseEvent } from 'primeng/tabview';

@Component({
  selector: 'eo-tabs',
  templateUrl: './eo-tabs.component.html',
  styleUrl: './eo-tabs.component.scss',
})
export class EoTabsComponent {
  private _config?: EoTabsConfig;
  get config(): IEoTabsConfig | undefined {
    return this._config;
  }
  @Input() set config(value: IEoTabsConfig) {
    this._config = value;
  }

  onChange(event: TabViewChangeEvent): void {
    if (this.config) {
      this.config.activeIndex = event.index;
    }

    this.config?.onChange?.(event);
  }

  onClose(event: TabViewCloseEvent): void {
    this.config?.onClose?.(event);
  }

  onActiveIndexChange(event: number): void {
    if (this.config) {
      this.config.activeIndex = event;
    }

    this.config?.activeIndexChange?.(event);
  }

  getTabs(): EoTabConfig[] {
    return this.config?.tabs ?? [];
  }
}
